module.exports = __webpack_public_path__ + "static/media/carrier-auth-dealer-logo.422c3b8c.jpg";